import { IconButton, Stack, Typography } from '@mui/material'
import ExamDetailsList from './ExamDetailsList'
import ExamReason from './ExamReason'
import { QcTaskState, QcTimepointContainerSubmission } from '@common/config/api/client'
import CommentModal, { SiteCommentItem } from '../modals/CommentModal'
import { getAdherenceCommentText } from '@common/utils/parseContainerComments'
import { SPACING } from '@common/theme/spacing'

/**
 * Build labeled comment rows for the QC message-icon table modal.
 * Modal shows only adherence + optional/additional comments.
 * Override (structured or legacy plain text with a reason) stays in ExamReason.
 */
export function buildSiteCommentArray(container: QcTimepointContainerSubmission): SiteCommentItem[] {
  const commentArray: SiteCommentItem[] = []
  const hasOverrideReason = Boolean(container.no_file_submission_reason?.trim())
  const adherence = getAdherenceCommentText(container.comments, hasOverrideReason)
  if (adherence) {
    commentArray.push({ label: 'Adherence check', text: adherence })
  }

  if (container.additional_comments?.trim()) {
    commentArray.push({ label: 'Optional comment', text: container.additional_comments.trim() })
  }

  return commentArray
}

export default function Exam({
  qcTaskOrder,
  qcTaskStatus,
  timepointSubmissionId,
  container,
}: {
  qcTaskOrder: number
  qcTaskStatus: QcTaskState
  timepointSubmissionId: string
  container: QcTimepointContainerSubmission
}) {
  const commentArray = buildSiteCommentArray(container)
  const hasFiles = (container.exam_metadata?.length ?? 0) > 0
  const hasReason = Boolean(container.no_file_submission_reason?.trim())

  return (
    <Stack spacing={SPACING.formFieldsSpacing}>
      <Stack spacing={SPACING.minSpacing}>
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Typography variant="subtitle2" sx={{ color: 'text.secondary' }}>
            {container.container_requirement_name}
          </Typography>
          <IconButton>
            <CommentModal
              comment={commentArray}
              authorName={container.comment_author_name}
              requirementName={container.container_requirement_name}
            />
          </IconButton>
        </Stack>
        {hasReason ? <ExamReason reason={container.no_file_submission_reason} comment={container.comments} /> : null}
        {hasFiles || !hasReason ? (
          <ExamDetailsList
            qcTaskOrder={qcTaskOrder}
            qcTaskStatus={qcTaskStatus}
            timepointSubmissionId={timepointSubmissionId}
            container={container}
          />
        ) : null}
      </Stack>
    </Stack>
  )
}
